import { render, staticRenderFns } from "./MemberBillsMBL.vue?vue&type=template&id=2bf54a0e&scoped=true"
import script from "./MemberBillsMBL.vue?vue&type=script&lang=js"
export * from "./MemberBillsMBL.vue?vue&type=script&lang=js"
import style0 from "./MemberBillsMBL.vue?vue&type=style&index=0&id=2bf54a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf54a0e",
  null
  
)

export default component.exports